import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SchoolApi } from '../+api';
import { DalOptions, DAL_OPTIONS } from '../dal.module';
import {
  PassportUserCredentialInterface,
  PersonInterface,
  SchoolProviderInterface,
  SchoolRoleMappingInterface,
} from '../+models';
import { SchoolProviderServiceInterface } from './school-provider.service.interface';
import { SmscClassGroupInterface } from './smsc-class-group.interface';

@Injectable({
  providedIn: 'root',
})
export class SchoolProviderService implements SchoolProviderServiceInterface {
  private httpService = inject(HttpClient);
  private schoolApi = inject(SchoolApi);
  private dalOptions = inject<DalOptions>(DAL_OPTIONS);
  private basePath = this.dalOptions.apiBaseUrl + '/api/SchoolProviders/';

  deleteSchoolProvider(schoolId: number, schoolProviderId: number): Observable<number[]> {
    return this.schoolApi
      .unlinkProvider(schoolId, schoolProviderId)
      .pipe(
        map(
          (result: { schoolProvider: SchoolProviderInterface; schoolRoleMappingIds: number[] }) =>
            result.schoolRoleMappingIds
        )
      );
  }

  createSchoolProvider(
    schoolId: number,
    schoolProvider: SchoolProviderInterface
  ): Observable<{
    schoolProvider: SchoolProviderInterface;
    credentials: PassportUserCredentialInterface[];
    schoolRoleMappings: SchoolRoleMappingInterface[];
    persons: PersonInterface[];
  }> {
    return this.schoolApi.linkProvider(schoolId, schoolProvider) as Observable<{
      schoolProvider: SchoolProviderInterface;
      credentials: PassportUserCredentialInterface[];
      schoolRoleMappings: SchoolRoleMappingInterface[];
      persons: PersonInterface[];
    }>;
  }

  updateProvider(schoolProvider: SchoolProviderInterface): Observable<SchoolProviderInterface> {
    const url = `${this.basePath}${schoolProvider.id}/update`;
    return this.httpService.put<SchoolProviderInterface>(url, schoolProvider, { withCredentials: true });
  }

  syncProvider(schoolProviderId: number): Observable<any> {
    const url = `${this.basePath}${schoolProviderId}/sync`;
    return this.httpService.post<any>(url, undefined, { withCredentials: true });
  }

  testConnection(schoolProvider: SchoolProviderInterface): Observable<{ connected: boolean }> {
    const url = `${this.basePath}test-connection`;
    return this.httpService.post<{ connected: boolean }>(url, schoolProvider, { withCredentials: true });
  }

  createNewSchoolProvider(schoolProvider: SchoolProviderInterface): Observable<SchoolProviderInterface> {
    const url = `${this.basePath}create`;

    return this.httpService.post<SchoolProviderInterface>(url, schoolProvider, { withCredentials: true });
  }

  deleteNewSchoolProvider(schoolProviderId: number): Observable<number> {
    const url = `${this.basePath}${schoolProviderId}/delete`;

    return this.httpService.delete<number>(url, { withCredentials: true });
  }

  getSmscClassGroups(schoolProviderId: number): Observable<SmscClassGroupInterface[]> {
    const url = `${this.basePath}${schoolProviderId}/smsc-class-groups`;
    return this.httpService.get<SmscClassGroupInterface[]>(url, { withCredentials: true });
  }
}
